import { EntityType } from '@frontend/common';
import { IEquipment } from '@frontend/equipment/types';
import { CommonMessage } from '@frontend/lang';
import { LaundryEquipmentClient } from '@frontend/laundry-app/api';
import { CreateLaundryEquipment } from '@frontend/laundry-app/types';
import { useAccountRepository } from '@frontend/repository';
import { WorkflowType } from '@frontend/workflow/types';
import { useState } from 'react';

import CreateModal from '../../../modal/create-modal/create-modal.component';

interface CreateItemModalProps {
    formId?: string;
}

export const CreateItemModal = (props: CreateItemModalProps) => {
    const { currentAccount } = useAccountRepository();
    const [showMoreOptions, setShowMoreOptions] = useState<boolean>(false);

    return (
        <CreateModal<IEquipment, CreateLaundryEquipment>
            order={['tag', 'serial_number', 'product_id', 'owner_id']}
            required={['serial_number', 'product_id']}
            formId={props.formId}
            onSubmit={(v) => LaundryEquipmentClient.postLaundryEquipment(currentAccount, v)}
            type={EntityType.EQUIPMENT}
            title={CommonMessage.FORMS.BASIC_INFORMATION}
            label={CommonMessage.FORMS.CREATE_OBJECT(CommonMessage.OBJECTS.COMMON_FIELDS.ITEM)}
            keyOverwrite={
                new Map([
                    ['serial_number', 'SN'],
                    ['owner_id', 'Assign to user']
                ])
            }
            submitDisabled={(val) => !val['product_id'] || !val['serial_number']}
            submitButtonOverride={CommonMessage.FORMS.CREATE_OBJECT(CommonMessage.OBJECTS.COMMON_FIELDS.ITEM)}
            subForms={
                new Map([
                    [
                        CommonMessage.FORMS.ADVANCED_SETTINGS,
                        {
                            order: ['state', 'workflow_id'],
                            required: ['state', 'workflow_id'],
                            show: showMoreOptions,
                            enumOverwrite: new Map([['state', 'equipment_state_v2']]),
                            fieldProps: new Map([
                                [
                                    'workflow_id',
                                    {
                                        queryParams: {
                                            account_id: currentAccount,
                                            type: WorkflowType.EQUIPMENT
                                        }
                                    }
                                ]
                            ])
                        }
                    ]
                ])
            }
            footerButton={
                <button
                    type='button'
                    onClick={() => setShowMoreOptions(!showMoreOptions)}
                    className='text-brand-primary hover:text-brand-secondary cursor-pointer p-0 font-medium'>
                    {showMoreOptions ? CommonMessage.FORMS.LESS_OPTIONS : CommonMessage.FORMS.MORE_OPTIONS}
                </button>
            }
        />
    );
};
